





































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import numeral from "numeral";
import { ServerResult } from "@/core/http/server_result";
import { STORE_KEY, numericId } from "./_store";

const REPORT_KEY = "PRODUCE_WEEK_PLAN_LOG";

@Component
export default class ViewLog extends Vue {
  @Prop() value!: number;
  @Prop() stats!: any;
  @Prop() base_weight!: number;
  @Prop() type_id!: number;
  @Prop() zone!: number;
  @Prop() date!: number;
  @Prop() zone_name!: number;
  @Prop() item!: any;
  @Prop() date_from!: string;
  @Prop() date_to!: string;
  @Prop() zone_id!: number;
  /** Дата ячейки (пн 16.03) — для фильтра истории только по этой ячейке */
  @Prop() cell_date!: string;
  /** plan — план З/П; fact_tk — факт отгрузок со склада (сделки) */
  @Prop({ default: "plan" }) detailKind!: string;

  history: any[] = [];
  historyLoading = false;
  detailLoading = false;
  detailError = "";
  calcStats: any = null;

  get isFactTkDetail(): boolean {
    return this.detailKind === "fact_tk";
  }

  get valueTitle(): string {
    return this.isFactTkDetail ? "Факт ТК" : "План производства";
  }

  get canShowHistory(): boolean {
    if (this.isFactTkDetail) return false;
    return (
      this.zone_id != null &&
      this.item?.product_container_id != null &&
      this.type_id_num != null &&
      this.date_from != null &&
      this.date_to != null
    );
  }

  get type_id_num(): number | null {
    if (this.type_id == null) return null;
    const s = String(this.type_id);
    const m = s.match(/\d+$/);
    return m ? parseInt(m[0], 10) : null;
  }

  get statsTableData(): any[] {
    const source = this.calcStats ?? this.stats;
    if (!source) return [];
    const s = source;
    if (Array.isArray(s)) {
      if (s.length > 0 && Array.isArray(s[0])) return s[0];
      return s;
    }
    if (s && typeof s === "object") {
      if (Array.isArray((s as any).stats)) return (s as any).stats;
      if ((s as any)[0]) {
        const inner = (s as any)[0];
        return Array.isArray(inner) ? inner : s;
      }
    }
    return [];
  }

  get tableData(): any[] {
    const rows = this.statsTableData;
    const prepared = this.isFactTkDetail
      ? this.aggregateFactTkByDate(rows)
      : rows;
    return prepared.filter((row) => this.rowWeightKg(row) > 1e-9);
  }

  aggregateFactTkByDate(rows: any[]): any[] {
    const map = new Map<
      string,
      {
        date: string;
        week_num: number | null;
        container_quantity: number;
        weight_kg: number;
      }
    >();
    for (const row of rows) {
      const dateKey = this.toDateKey(row?.date);
      if (!dateKey) continue;
      let agg = map.get(dateKey);
      if (!agg) {
        agg = {
          date: dateKey,
          week_num:
            row?.week_num != null && row.week_num !== ""
              ? Number(row.week_num)
              : null,
          container_quantity: 0,
          weight_kg: 0,
        };
        map.set(dateKey, agg);
      }
      agg.container_quantity += Number(row.container_quantity) || 0;
      agg.weight_kg += Number(row.weight_kg) || 0;
      if (agg.week_num == null && row?.week_num != null && row.week_num !== "") {
        agg.week_num = Number(row.week_num);
      }
    }
    return Array.from(map.values()).sort((a, b) =>
      String(a.date).localeCompare(String(b.date)),
    );
  }

  toDateKey(value: any): string | null {
    if (!value) return null;
    if (typeof value === "string") return value.slice(0, 10);
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }

  mounted() {
    if (this.isFactTkDetail) {
      this.loadFactTkDetail();
      return;
    }
    this.calcStats = this.stats;
    if (this.canShowHistory) {
      this.loadHistory();
    }
  }

  async loadFactTkDetail() {
    const dateFrom = this.cell_date ?? this.date_from;
    const dateTo = this.cell_date ?? this.date_to;
    const zoneGroupId = this.zone_id;
    const productContainerId = numericId(this.item?.product_container_id);

    if (!dateFrom || !dateTo || zoneGroupId == null || productContainerId == null) {
      this.detailError = "Не удалось подготовить параметры детализации ТК";
      return;
    }

    this.detailLoading = true;
    this.detailError = "";
    try {
      const payload = await this.$store.dispatch(
        `${STORE_KEY}/loadMonthCellDetail`,
        {
          detail_type: "fact_tk",
          date_from: dateFrom,
          date_to: dateTo,
          delivery_zone_group_id: zoneGroupId,
          product_container_id: productContainerId,
        },
      );
      const dealRows = Array.isArray(payload?.deal_rows) ? payload.deal_rows : [];
      this.calcStats =
        dealRows.length > 0
          ? dealRows
          : (Array.isArray(payload?.daily_rows) ? payload.daily_rows : []).map(
              (row: any) => ({
                date: row.date,
                week_num: null,
                deal_id: null,
                type_id: null,
                container_quantity: 0,
                weight_kg: row.fact_quantity ?? 0,
              }),
            );
    } catch (error) {
      const e = error as any;
      this.detailError =
        e?.response?.data?.error ||
        e?.message ||
        "Ошибка загрузки детализации ТК";
    } finally {
      this.detailLoading = false;
    }
  }

  loadHistory() {
    if (!this.canShowHistory) return;
    this.historyLoading = true;
    const vm = (this as any)._vm || this;
    const pid = this.item?.product_container_id;
    const numId = typeof pid === "object" && pid?.pk != null ? pid.pk : pid;
    vm.$db([
      vm
        .$q(REPORT_KEY)
        .raw("produce_week_plan_log")
        .action({
          delivery_zone_group_id: this.zone_id,
          product_container_id: numId,
          type_id: this.type_id_num,
          date_from: this.cell_date ?? this.date_from,
          date_to: this.cell_date ?? this.date_to
        })
    ])
      .then((result: ServerResult) => {
        const doc = result.getOperation(REPORT_KEY).getContent().documents?.[0];
        this.history = doc?.history ?? [];
        if (doc?.calc_stats != null) {
          this.calcStats = doc.calc_stats;
        }
      })
      .finally(() => {
        this.historyLoading = false;
      });
  }

  /** Значение в тарах → кг для отображения на вкладке История */
  quantityToKg(tarValue: number | null | undefined): number {
    if (tarValue == null || this.base_weight <= 0) return 0;
    return Number(tarValue) * this.base_weight;
  }

  /** Тип изменения на русском для вкладки История */
  changeTypeLabel(changeType: string | null | undefined): string {
    if (!changeType) return "";
    const map: Record<string, string> = {
      calculated: "Расчёт",
      manual_update: "Ручное изменение",
      date_transfer: "Перенос даты",
      date_transfer_in: "Перенос на дату (приход)",
      date_transfer_out: "Перенос с даты (уход)",
    };
    return map[String(changeType).toLowerCase()] ?? changeType;
  }

  rowWeightKg(row: any): number {
    if (row?.weight_kg != null && row.weight_kg !== "") {
      return Number(row.weight_kg) || 0;
    }
    return Number(row.container_quantity || 0) * Number(this.base_weight || 0);
  }

  dealsHref(row: any): string {
    const date = row?.date;
    const warehousePart = this.isFactTkDetail
      ? "&warehouses=d%3Awarehouses%3A6"
      : "";
    if (this.isFactTkDetail) {
      return `/deals?deliveryZoneGroups=${this.zone}&dates=${date}&dates=${date}&status=d%3Astatuses%3A16${warehousePart}`;
    }
    return `/deals?deliveryZoneGroups=${this.zone}&dates=${date}&dates=${date}&dealsTypes=${this.type_id}&status=d%3Astatuses%3A16${warehousePart}`;
  }

  rowClass(row: any, index: number) {
    if (this.isFactTkDetail) return "";
    return numeral(this.rowWeightKg(row))
      .value()
      .toFixed(2) ===
      numeral(this.value)
        .value()
        .toFixed(2)
      ? "priv-row"
      : "";
  }

  getWeekNum(row: any): number {
    if (row?.week_num != null && row?.week_num !== "") {
      return Number(row.week_num);
    }
    const date = new Date(row?.date);
    if (Number.isNaN(date.getTime())) return 0;
    // ISO week: Thursday-based week year.
    const utc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = utc.getUTCDay() || 7;
    utc.setUTCDate(utc.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(utc.getUTCFullYear(), 0, 1));
    return Math.ceil((((utc.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  }

  close() {
    this.$emit("close");
  }
}
